import {useContext, useEffect, useState} from "react";
import $ from "jquery";
import "../styles/css/login-public.css"
import "../styles/css/admin-style.css"
import {useNavigate, useSearchParams} from "react-router-dom";
import eventEmitter from "../shared/eventEmitter";
import {EventEmitterTypes} from "../shared/eventEmitterEnum";
import {AuthenticationHandler} from "../components/auth/AuthenticationHandler";
import notificationService from "../services/NotificationService";
import {useForm} from "react-hook-form";
import {publicCustomerService} from "../services/publicCustomerService";
import {formatWebId, SplitAddressFromGoogleAddressComponents} from "../shared/sharedFunctions";
import AuthClientStore from "../components/auth/AuthClientStore";
import AddressInput from "../shared/components/AutocompleteAddressInput";

const PublicLoginPage: React.FC = () => {
    const { register, handleSubmit, setValue, getValues } = useForm();
    const auth = useContext(AuthenticationHandler);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [webId, setWebId] = useState('');
    const [showLogin, setShowLogin] = useState(false)
    const [showPayment, setShowPayment] = useState(false)
    const [customerNumber, setCustomerNumber] = useState('')
    const [paymentPlace, setPaymentPlace] = useState<any>(null)
    const [verifyResult, setVerifyResult] = useState<'nothing-due' | 'error' | null>(null)
    const [verifying, setVerifying] = useState(false)

    async function handlePostLogin() {
        const r = await publicCustomerService.getCustomerInfo(AuthClientStore.getWebUniqueId());
        if (!r) {
            navigate('/no-request-ready');
            return;
        }
        if (!r.jobDateScheduled)
            navigate('/member/schedule-estimate', { state: { requestData: r } });
        else
            navigate('/member/reschedule-estimate', { state: { requestData: r } });
    }

    const onSubmit = async data => {
        if(!webId || webId === ''){
            notificationService.error("WebId is a required field")
            return;
        }
        const success = await auth.customerLoginUsingWebId(webId)
        if (success) handlePostLogin();
    }
    useEffect(() => {
        document.body.classList.remove('bg-white');
    },[])
    useEffect(() => {
        const urlWebId = searchParams.get('webId');
        const urlCustomerId = searchParams.get('customerId');
        const urlStreetNumber = searchParams.get('streetNumber');
        const urlStreetName = searchParams.get('streetName');
        const urlPostalCode = searchParams.get('postalCode');

        if (urlWebId) {
            auth.customerLoginUsingWebId(urlWebId).then(success => {
                if (success) handlePostLogin();
            });
        } else if (urlCustomerId && urlStreetNumber && urlStreetName && urlPostalCode) {
            publicCustomerService.findByCustomerNumber(
                parseInt(urlCustomerId), urlStreetNumber, urlStreetName, urlPostalCode
            ).then(res => {
                if (!res) {
                    notificationService.error("Customer not found. Please check your link or manually enter your Web ID.");
                    return;
                }
                AuthClientStore.setWebUniqueId(res.uniqueId);
                handlePostLogin();
            });
        }
    }, [])
    return (
        <div className="login-public-body">
            <div className="">
                <div className="login-container g-0 fullHeight">
                    <div className="row g-0" style={{height: "100vh"}}>

                        <div className="col-12 g-0 h-100 overflow-scroll bg-white interactionSide">
                            <div className="overflow-scroll w-100 h-100">

                                <div className="actionsWrap">
                                    <div className="logoContainer mb-5">
                                        <img src="/logo/logoBigger.svg" alt="Barreca logo" className="logo"/>
                                    </div>

                                    {!showLogin && !showPayment &&
                                        <>
                                            <div className="doSomething mb-4">
                                                <h2>Learn more</h2>
                                                <p>Fill out our form to request a quote.</p>
                                                <button onClick={() => navigate('/request-estimate')} type="button"
                                                        className="btn btn-lg btn-primary hvr-grow shadow">Request a
                                                    Quote
                                                </button>
                                            </div>

                                            <div className="doSomething">
                                                <h2>Already a customer?</h2>
                                                <p>Login to your customer portal.</p>
                                                <button type="button" onClick={() => setShowLogin(true)}
                                                        className="btn btn-lg btn-outline-primary hvr-grow shadow mb-2">Login
                                                </button>
                                                <button type="button" onClick={() => setShowPayment(true)}
                                                        className="btn btn-lg btn-outline-primary hvr-grow shadow ">Make A Payment
                                                </button>
                                            </div>
                                        </>
                                    }
                                    {showLogin &&
                                        <div className="wizard-step">
                                            <a href="#" className="step-back">
                                                <p className="text-black opacity-75 mb-5 fw-medium" onClick={() => setShowLogin(false)}><i
                                                    className="fa fa-regular fa-arrow-left"></i> Back</p>
                                            </a>
                                            <h1 className="fw-bold text-center mb-4">Customer Login</h1>
                                            <form onSubmit={handleSubmit(onSubmit)}>
                                                <fieldset className="form-group mb-3">
                                                    <div className="form-floating">
                                                        <input type="text" className="form-control form-control-lg" 
                                                               value={webId}
                                                               onChange={(e) => {
                                                                    const raw = e.target.value;
                                                                    const formatted = formatWebId(raw);
                                                                    setWebId(formatted);
                                                                }}
                                                               placeholder="Web ID" required/>
                                                        <label>Web ID</label>
                                                    </div>
                                                </fieldset>
                                            </form>
                                            <button type="button" onClick={onSubmit}
                                                    className="btn btn-lg btn-block btn-primary login-btn w-100 text-white shadow">Login
                                            </button>
                                            {/* <!-- for later: give them a picture of where to find the WebID -->
                                                <!-- <div class="mt-4">
                                                    <a href="#"><small class="text-primary">How do I find my Web ID?</small></a>
                                                </div> -->*/}
                                        </div>
                                    }
                                    {showPayment &&
                                        <div className="wizard-step wizard-payment">
                                            <a href="#" className="step-back-payment" onClick={(e) => { e.preventDefault(); setShowPayment(false); setVerifyResult(null); setCustomerNumber(''); setPaymentPlace(null); }}>
                                                <p className="text-black opacity-75 mb-5 fw-medium"><i
                                                    className="fa fa-regular fa-arrow-left"></i> Back</p>
                                            </a>
                                            <h1 className="fw-bold text-center mb-4">Make a Payment</h1>
                                            <p className="text-center">Enter your Customer ID and select your property address to view outstanding invoices.</p>
                                            <form>
                                                <fieldset className="form-group mb-3">
                                                    <div className="form-floating">
                                                        <input type="text" className="form-control form-control-lg"
                                                               value={customerNumber}
                                                               onChange={(e) => { setCustomerNumber(e.target.value.replace(/\D/g, '')); setVerifyResult(null); }}
                                                               placeholder="Customer ID" required/>
                                                        <label>Customer ID</label>
                                                    </div>
                                                </fieldset>
                                                <fieldset className="form-group mb-3">
                                                    <label className="mb-1">Job Address</label>
                                                    <AddressInput
                                                        onLocation={() => {}}
                                                        setPlace={(place) => { setPaymentPlace(place); setVerifyResult(null); }}
                                                        className="form-control form-control-lg"
                                                    />
                                                </fieldset>
                                            </form>
                                            <button type="button"
                                                    disabled={verifying}
                                                    onClick={async () => {
                                                        if (!customerNumber) {
                                                            notificationService.error("Customer ID is required.");
                                                            return;
                                                        }
                                                        if (!paymentPlace || !paymentPlace.address_components) {
                                                            notificationService.error("Please select an address from the dropdown.");
                                                            return;
                                                        }
                                                        const addressParts = SplitAddressFromGoogleAddressComponents(paymentPlace.address_components);
                                                        setVerifying(true);
                                                        setVerifyResult(null);
                                                        try {
                                                            const response = await publicCustomerService.verifyForPayment(
                                                                parseInt(customerNumber),
                                                                addressParts.streetNumber,
                                                                addressParts.streetName,
                                                                addressParts.postalCode
                                                            );
                                                            if (!response) {
                                                                setVerifyResult('error');
                                                                return;
                                                            }
                                                            if (response.outstandingJobs && response.outstandingJobs.length > 0) {
                                                                navigate('/make-payment', { state: { customerData: response } });
                                                            } else {
                                                                setVerifyResult('nothing-due');
                                                            }
                                                        } catch {
                                                            setVerifyResult('error');
                                                        } finally {
                                                            setVerifying(false);
                                                        }
                                                    }}
                                                    className="btn btn-lg btn-block btn-primary login-btn w-100 text-white shadow">
                                                {verifying ? 'Searching...' : 'View'}
                                            </button>
                                            {verifyResult === 'nothing-due' &&
                                                <div className="alert alert-success mt-3" role="alert">
                                                    <div className="d-flex align-items-center">
                                                        <i className="fas fa-circle-check fa-2x text-success me-3"></i>
                                                        <div>
                                                            <strong>All paid up!</strong>
                                                            <p className="mb-0 small">Your invoice is paid and nothing is
                                                                due at this time.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {verifyResult === 'error' &&
                                                <div className="alert alert-danger mt-3" role="alert">
                                                    <div className="d-flex align-items-center">
                                                        <i className="fas fa-circle-exclamation fa-2x text-danger me-3"></i>
                                                        <div>
                                                            <strong>No match found</strong>
                                                            <p className="mb-0 small">We couldn't find a matching customer with that ID and address. Please double-check your information.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    }

                                </div>


                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default PublicLoginPage;
